export const MAIL_FOLDER_INBOX = 'mail_inbox';
export const MAIL_FOLDER_DRAFTS = 'mail_drafts';

export const PERSIST_MAIL_FOLDER_KEY = 'MailFolderFilter';